import React, { useState, useEffect, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import _ from "lodash";
import { NavLink, useLocation } from "react-router-dom";
import { Dialog, Menu, Transition } from "@headlessui/react";

// constants
import LocalStrings from "../../languages/LocalStrings";
import IcomoonIcons from "../Common/IcomoonIcons";

// actions
import {
  setAddCodeModalDetails,
  setCommonEditModalDetails,
} from "../../actions/index";

// files
import Cross from "../../assets/img/icons/cross-icon.svg";
import EventIcon from "../../assets/img/icons/event.svg";

import LogoutIcon from "../../assets/img/icons/logout.svg";

const SideBar = (props) => {
  const location = useLocation();
  const { isSideMenuOpen, setIsSideMenuOpen, partnerDetails, session } = props;

  let activeTab = "";
  if (location.pathname.includes("/plan")) {
    activeTab = "plan";
  } else if (location.pathname.includes("/userlist")) {
    activeTab = "userlist";
  } else if (location.pathname.includes("/reportedcontacts")) {
    activeTab = "reportedcontacts";
  }
  const handlePushNotificationClick = () => {
    props.setCommonEditModalDetails({
      show: true,
      calledFrom: "push-notofication",
    });
  };

  const _handleLogout = () => {
    props.setAddCodeModalDetails({
      show: true,
      calledFrom: "logout",
      data: {},
    });
  };

  return (
    <>
      {/* ----- mobile ----- */}
      <Transition.Root show={isSideMenuOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-20 md:hidden"
          onClose={setIsSideMenuOpen}
        >
          <Transition.Child
            as={Fragment}
            enter="transition ease-in-out duration-150"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="transition ease-in-out duration-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 z-10 items-end bg-black bg-opacity-50 sm:items-center sm:justify-center"></div>
          </Transition.Child>

          <aside className="fixed inset-y-0 z-20">
            <Transition.Child
              as={Fragment}
              enter="transition ease-in-out duration-150"
              enterFrom="opacity-0 transform -translate-x-20"
              enterTo="opacity-100"
              leave="transition ease-in-out duration-150"
              leaveFrom="opacity-100"
              leaveTo="opacity-0 transform -translate-x-20"
            >
              <Dialog.Panel className="relative">
                {/* ----- cross icon ----- */}
                <Transition.Child
                  as={Fragment}
                  enter="ease-in-out duration-300"
                  enterFrom="opacity-0"
                  enterTo="opacity-100"
                  leave="ease-in-out duration-300"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                >
                  <div className="absolute top-0 right-0 -mr-12 pt-2">
                    <button
                      type="button"
                      className="ml-1 flex items-center justify-center bg-white h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                      onClick={() => setIsSideMenuOpen(false)}
                    >
                      {/* <span className="sr-only">Close sidebar</span> */}
                      <span className="h-6 w-6 text-white" aria-hidden="true">
                        <img src={Cross} alt="close" />
                      </span>
                    </button>
                  </div>
                </Transition.Child>

                <div className="flex-shrink-0 w-64 mt-16- h-screen overflow-y-auto bg-white">
                  <div className="py-4 text-gray-500 dark:text-gray-400">
                    <NavLink
                      className="ml-4 text-lg font-bold text-kipplocolor"
                      to={"/plan"}
                    >
                      Super Admin
                    </NavLink>
                    <ul className="mt-6">
                      <li
                        className="relative px-6 py-3"
                        onClick={() => setIsSideMenuOpen(false)}
                      >
                        <NavLink
                          className={`inline-flex items-center w-full text-sm ${
                            activeTab === "/" || activeTab === "plan"
                              ? "bg-kipplobg text-white"
                              : "text-kipplocolor hover:bg-kipplohover hover:text-white"
                          } transition-colors duration-150 hover:text-white p-2.5 rounded-md`}
                          to={"/plan"}
                        >
                          <img
                            src={EventIcon}
                            alt="event goes here"
                            className="w-5 h-5"
                          />
                          <span className="ml-4">All Plans</span>
                        </NavLink>
                      </li>
                      <li
                        className="relative px-6 py-3"
                        onClick={() => setIsSideMenuOpen(false)}
                      >
                        <NavLink
                          className={`inline-flex items-center w-full text-sm ${
                            activeTab === "userlist"
                              ? "bg-kipplobg text-white"
                              : "text-kipplocolor hover:bg-kipplohover hover:text-white"
                          } transition-colors duration-150 hover:text-white p-2.5 rounded-md`}
                          to={"/userlist"}
                        >
                          <img
                            src={EventIcon}
                            alt="event goes here"
                            className="w-5 h-5"
                          />
                          <span className="ml-4">Users</span>
                        </NavLink>
                      </li>
                      <li
                        className="relative px-6 py-3"
                        onClick={() => setIsSideMenuOpen(false)}
                      >
                        <NavLink
                          className={`inline-flex items-center w-full text-sm ${
                            activeTab === "reportedcontacts"
                              ? "bg-kipplobg text-white"
                              : "text-kipplocolor hover:bg-kipplohover hover:text-white"
                          } transition-colors duration-150 hover:text-white p-2.5 rounded-md`}
                          to={"/reportedcontacts"}
                        >
                          <img
                            src={EventIcon}
                            alt="event goes here"
                            className="w-5 h-5"
                          />
                          <span className="ml-4">Reported Contacts</span>
                        </NavLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </aside>
        </Dialog>
      </Transition.Root>

      {/* ----- desktop ----- */}
      <aside className="z-20 hidden w-48 overflow-y-auto bg-white  md:block flex-shrink-0 shadow-md">
        <div className="py-4 text-gray-500 dark:text-gray-400">
          <NavLink
            className="ml-4 text-lg font-bold text-kipplocolor"
            to={"/program"}
          >
            Super AdminPanel
          </NavLink>
          <ul className="mt-6">
            <li className="relative py-1">
              <div className="w-full py-3- ">
                <NavLink
                  className={`inline-flex items-center w-full p-1 text-sm font-semibold ${
                    activeTab === "/" || activeTab === "plan"
                      ? "bg-kipplobg text-white"
                      : "text-kipplocolor hover:bg-primary hover:text-white"
                  }  transition-colors duration-150 hover:text-white`}
                  to={"/plan"}
                >
                  <span className="ml-3 icomoon text-base">
                    {IcomoonIcons.barchart1Icon}
                  </span>
                  <span className="ml-4">All Plans</span>
                </NavLink>
              </div>
            </li>
            <li className="relative py-1">
              <div className="w-full py-3- ">
                <NavLink
                  className={`inline-flex items-center w-full p-1 text-sm font-semibold  ${
                    activeTab === "userlist"
                      ? "bg-kipplobg text-white"
                      : "text-kipplocolor hover:bg-primary hover:text-white"
                  }   `}
                  to={"/userlist"}
                >
                  <span className="ml-3 icomoon text-base">
                    {IcomoonIcons.multiUserIcon}
                  </span>
                  <span className="ml-4">Users</span>
                </NavLink>
              </div>
            </li>
            <li className="relative py-1">
              <div className="w-full py-3- ">
                <NavLink
                  className={`inline-flex items-center w-full p-1 text-sm font-semibold  ${
                    activeTab === "reportedcontacts"
                      ? "bg-kipplobg text-white"
                      : "text-kipplocolor hover:bg-primary hover:text-white"
                  }   `}
                  to={"/reportedcontacts"}
                >
                  <span className="ml-3 icomoon text-base">
                    {IcomoonIcons.multiUserIcon}
                  </span>
                  <span className="ml-4">Reported Contacts</span>
                </NavLink>
              </div>
            </li>
            <li className="py-1 absolute bottom-0">
              <div
                className="inline-flex items-center w-full px-2 py-1 text-sm font-semibold duration-150 cursor-pointer ml-2 mb-4 hover:opacity-80"
                onClick={_handleLogout}
              >
                <span className="hidden lg:block mr-2 text-primary">
                  {LocalStrings.button_logout}
                </span>
                <img src={LogoutIcon} alt="logout" className="h-4 w-4" />
              </div>
            </li>
          </ul>
        </div>
      </aside>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    partnerDetails: state.partnerDetails,
    session: state.session,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { setCommonEditModalDetails, setAddCodeModalDetails },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
